
import { defineComponent, PropType } from '@vue/composition-api';
import DonutRing from './DonutRing.vue';

type DonutSegmentInput = {
  value: number;
  colorVar: string;
};

export default defineComponent({
  name: 'StatsGraph',
  components: {
    DonutRing
  },

  props: {
    Title: {
      type: String,
      required: true
    },
    segments: {
      type: Array as PropType<DonutSegmentInput[]>,
      required: true
    }
  }
});
